import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Screen Reader Announcements Component
 * Announces page changes and important updates to screen readers
 */
export function ScreenReaderAnnouncements() {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    // Create or update live region for announcements
    let liveRegion = document.getElementById('sr-live-region');
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.id = 'sr-live-region';
      liveRegion.setAttribute('role', 'status');
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      liveRegion.className = 'sr-only';
      document.body.appendChild(liveRegion);
    }

    // Announce page change
    const pageName = location.pathname === '/' 
      ? t('common.home', { defaultValue: 'الصفحة الرئيسية' })
      : document.title || t('common.page', { defaultValue: 'صفحة' });
    
    liveRegion.textContent = `${t('a11y.pageLoaded', { defaultValue: 'تم تحميل' })} ${pageName}`;

    // Clear after announcement
    setTimeout(() => {
      if (liveRegion) liveRegion.textContent = '';
    }, 1000);
  }, [location.pathname, t]);

  return null;
}



